export const provide = {
  id: 'provide',
  viewBox: '0 0 512 512',
  svgBody: (
    <g>
      <path
        d='M437.02,74.98C388.67,26.63,324.38,0,256,0S123.33,26.63,74.98,74.98C26.63,123.33,0,187.62,0,256
		s26.63,132.67,74.98,181.02C123.33,485.37,187.62,512,256,512s132.67-26.63,181.02-74.98C485.37,388.67,512,324.38,512,256
		S485.37,123.33,437.02,74.98L437.02,74.98z M415.81,96.19c39.13,39.13,62.13,90.09,65.69,144.81h-40.15
		C433.69,145.45,353.49,70.04,256,70.04c-45.96,0-88.06,16.77-120.55,44.49L107,86.08C148.23,49.82,200.59,30,256,30
		C316.37,30,373.12,53.51,415.81,96.19z M256,411.96c-85.99,0-155.96-69.96-155.96-155.96S170.01,100.04,256,100.04
		c85.99,0,155.96,69.96,155.96,155.96S341.99,411.96,256,411.96z M30,256c0-55.27,19.72-107.5,55.8-148.69l28.46,28.46
		C86.7,168.21,70.04,210.2,70.04,256c0,97.39,75.25,177.52,170.66,185.32v40.16c-54.61-3.63-105.45-26.61-144.51-65.67
		C53.51,373.12,30,316.37,30,256z M415.81,415.81c-39.2,39.2-90.27,62.21-145.1,65.71v-40.14c90.74-7.13,163.37-79.68,170.65-170.38
		h40.15C477.94,325.72,454.94,376.68,415.81,415.81L415.81,415.81z'
      />
      <path
        d='M276.06,240.4c-13.57-4.8-28.58-10.59-36.99-17.19c-2.65-2.07-3.79-6.82-2.85-11.82c0.47-2.49,2.66-10.82,11.18-13.39
		c13.99-4.21,23.58,1.38,27.06,3.97c6.64,4.96,16.04,3.6,20.99-3.03c4.96-6.63,3.6-16.04-3.03-21c-3.15-2.35-11.03-7.51-22.34-10.02
		v-6.1c0-8.28-6.72-15-15-15s-15,6.72-15,15v7.08c-0.44,0.12-0.88,0.24-1.33,0.37c-16.43,4.95-28.7,18.96-32.01,36.56
		c-3.05,16.2,2.24,31.9,13.81,40.98c9.54,7.48,22.72,13.81,45.51,21.87c15.17,5.36,14.84,17.64,14,22.67
		c-1.71,10.2-10.29,21.22-25.08,21.32c-14.49,0.09-19.02-0.62-30.16-7.91c-6.93-4.53-16.23-2.59-20.76,4.34s-2.59,16.23,4.34,20.76
		c12.01,7.86,20.88,11.05,31.68,12.21v6.86c0,8.28,6.72,15,15,15c8.28,0,15-6.72,15-15v-8.3c8.26-2.27,15.79-6.43,22.23-12.35
		c9.12-8.38,15.28-19.73,17.33-31.97C313.82,271.46,300.33,248.98,276.06,240.4L276.06,240.4z'
      />
    </g>
  ),
}
